module.exports = __webpack_public_path__ + "static/Eyeglasss2_2-6d541d4716f707898c5b7f4d166c0a64.png";